import { SearchQueryOrderDirection } from "types/generated";

export const STACK_TASKS_FILTER_TYPE = "stack-tasks";
export const STACK_TASKS_INITIAL_SORT_OPTION = "createdAt";
export const STACK_TASKS_INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
